import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

const UsernameSection = ({avatarUrl, createdAt, platformHandle}) => {
    const profilePictureStyle = {
        backgroundImage: `url(${avatarUrl})`
    };
    const formattedDate = moment(createdAt).format('MMM D YYYY');

    return (
        <div className="username">
            <div className="profile-picture" style={profilePictureStyle} />
            <div className="username-info">
                {platformHandle}
                <div className="formatted-date">{formattedDate}</div>
            </div>
        </div>
    );
};

UsernameSection.propTypes = {
    avatarUrl: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    platformHandle: PropTypes.string.isRequired
};

export default UsernameSection;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/post_grid_item/username_section.js